import { render, staticRenderFns } from "./paper_report.vue?vue&type=template&id=52f093d0&scoped=true&"
import script from "./paper_report.vue?vue&type=script&lang=js&"
export * from "./paper_report.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52f093d0",
  null
  
)

export default component.exports